module Meevo.Components.Controls.SmartMover {
    import Dictionary = _.Dictionary;
    export class AlertsManagerUserTemplate extends DataTemplateBase implements IDataTemplate {
        protected _users: AlertsManagerEmployeeCollection;

        public title: string;
        public allSelectedLabel: string;
        public totalSelectedMessage: string;

        private _required: boolean;

        set required(value: boolean) {
            this._required = value;
            this.updateRequiredValidator(value, this.collection);
        }

        get required(): boolean {
            return this._required;
        }

        get collection(): ICollectionBase<any> {
            return this._users;
        }

        get totalSelectedCount(): number {
            return this._users.value.length;
        }

        get leafCollection() {
            return this._users;
        }

        reconnectLeafCollectionModel(model) {
            this.leafCollection.connectedModel = model[this.properties[0]];
        }

        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, properties, options.criteria);

            this._users = new AlertsManagerEmployeeCollection(this.model[properties[0]], [], {
                criteria: options.criteria,
                defaultValue: <ModelValueType[]>options.defaultValue
            })

            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_USERS' }, this)
            ];

            this._users.addFilters(...this.filters as IInteractiveFilter[]);

            this.title = 'LABEL_USER';
            this.allSelectedLabel = 'LABEL_ALL_USERS';
            this.totalSelectedMessage = 'LABEL_TOTAL_USERS_SELECTED';
        }
    }

}